import { render, staticRenderFns } from "./AddAdjustment.vue?vue&type=template&id=564d173c"
import script from "./AddAdjustment.vue?vue&type=script&lang=js"
export * from "./AddAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports